const BackButton = ({ onClick }) => (
  <button 
    onClick={onClick} 
    style={{
      position: 'fixed',
      left: 16,
      top: 16,
      fontSize: '1.2em',
      border: 'none',
      background: '#fff',
      borderRadius: '50%',
      width: 48,
      height: 48,
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      cursor: 'pointer',
      zIndex: 10
    }}
    aria-label="Back"
  >
    ←
  </button>
);

export default BackButton;